
export default {
    name:"smallCard",
    props: {
        index: Number,
        links: Array,
        card: Object
    },
    computed: {
         
        isThis: function()
        {
            return this.card.url == this.$route.path
        },    
        isWithinTag: function()
        {
            let selectedFilter =this.$store.state.page.content.filters; 
            console.log("list", selectedFilter);
            return true;
            //return card.tags.some(t => selectedFilter.includes(t));
        }
    },
    data()
    {
        return {
            cardLinks: this.links ? this.links : [{title: "View project"}],
            multilink: this.links && this.links.length > 1
        }
    }
}
